import { TRESPONSE_PLANI8_EMPLOYEE_LIST } from '@monorepo/types';
import { ModifiersZTableModel } from '../../table.modifier';

export const EMPLOYEE_LIST_PLANI8_TABLE_MODEL = {
  createModel: (
    items: TRESPONSE_PLANI8_EMPLOYEE_LIST['employees'],
    empConfig: TRESPONSE_PLANI8_EMPLOYEE_LIST['empListingConfig'],
    showArchiveAction: boolean = true,
  ) => {
    return ModifiersZTableModel.createTableModel(
      items,
      {
        headerConfig: [
          {
            type: 'TEXT_CELL',
            text: 'USERNAME',
          },
          {
            type: 'TEXT_CELL',
            text: 'NAME',
          },
          {
            type: 'TEXT_CELL',
            text: 'EMP ID',
          },
          {
            type: 'TEXT_CELL',
            text: 'TEAM',
            ...(showArchiveAction && {
              liftedInput: {
                input: {
                  type: 'DROPDOWN',
                  options: empConfig.teams.map((d) => ({ value: d.name, displayName: d.name })),
                  setValue: (v) => v.team || '',
                },
                metadata: {
                  keyName: 'team',
                  label: '',
                  isRequired: true,
                },
              },
            }),
          },
          {
            type: 'TEXT_CELL',
            text: 'ROLE',
            ...(showArchiveAction && {
              liftedInput: {
                input: {
                  type: 'DROPDOWN',
                  options: empConfig.roles.map((d) => ({ value: d.roleName, displayName: d.roleId })),
                  setValue: (v) => v.role || '',
                },
                metadata: {
                  keyName: 'role',
                  label: '',
                  isRequired: true,
                },
              },
            }),
          },
          {
            type: 'TEXT_CELL',
            text: 'FACTORY NAME',
            maxWidthInPx: 200,
            ...(showArchiveAction && {
              liftedInput: {
                input: {
                  type: 'DROPDOWN',
                  isMulti: true,
                  options: empConfig.factoryIdToNames.map((d) => ({ value: d.factoryId, displayName: d.factoryName })),
                  setValue: (v) => v.factoryIdsToNames.map((x) => x.factoryId),
                },
                metadata: {
                  keyName: 'factoryIds',
                  label: '',
                  isRequired: true,
                },
              },
            }),
          },
          {
            type: 'TEXT_CELL',
            text: 'BUYERS',
            maxWidthInPx: 200,
            ...(showArchiveAction && {
              liftedInput: {
                input: {
                  type: 'DROPDOWN',
                  isMulti: true,
                  options: empConfig.buyers.map((d) => ({ value: d, displayName: d })),
                  setValue: (v) => v.buyers,
                },
                metadata: {
                  keyName: 'buyers',
                  label: '',
                  isRequired: true,
                },
              },
            }),
          },
          ...(empConfig.productCategories.length > 0
            ? [
                {
                  type: 'TEXT_CELL' as const,
                  text: 'PRODUCT CATEGORY',
                  maxWidthInPx: 200,
                  isHidden: empConfig.productCategories.length === 0,
                  ...(showArchiveAction && {
                    liftedInput: {
                      input: {
                        type: 'DROPDOWN' as const,
                        isMulti: true,
                        options: empConfig.productCategories.map((d) => ({ value: d, displayName: d })),
                        setValue: (v: TRESPONSE_PLANI8_EMPLOYEE_LIST['employees'][number]) => v.productCategories,
                      },
                      metadata: {
                        keyName: 'productCategories',
                        label: '',
                        isRequired: true,
                      },
                    },
                  }),
                },
              ]
            : []),

          {
            type: 'TEXT_CELL',
            text: 'EMAIL ID',
          },
          {
            type: 'TEXT_CELL',
            text: 'PHONE NO',
          },
          {
            type: 'TEXT_CELL',
            text: '',
            widthInPx: 50,
          },
        ],
      },
      (item) => {
        return {
          type: 'ROW',
          rowItem: item,
          cells: [
            {
              type: 'TEXT_CELL',
              text: item.username,
            },
            {
              type: 'TEXT_CELL',
              text: item.name,
            },
            {
              type: 'TEXT_CELL',
              text: item.employeeId,
            },
            {
              type: 'TEXT_CELL',
              text: item.team || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.role || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.factoryIdsToNames.length > 0 ? item.factoryIdsToNames[0].factoryName : '--',
              ...(item.factoryIdsToNames.length > 1 && {
                tag: {
                  tagContent: `+${item.factoryIdsToNames.length - 1}`,
                  tagTooltipContent: item.factoryIdsToNames
                    .map((f) => f.factoryName)
                    .slice(1)
                    .join(', '),
                  showTooltipEvent: 'hover',
                },
              }),
            },
            {
              type: 'TEXT_CELL',
              text: item.buyers[0] || '--',
              ...(item.buyers.length > 1 && {
                tag: {
                  tagContent: `+${item.buyers.length - 1}`,
                  tagTooltipContent: item.buyers.slice(1).join(', '),
                  showTooltipEvent: 'hover',
                },
              }),
            },
            ...(empConfig.productCategories.length > 0
              ? [
                  {
                    type: 'TEXT_CELL' as const,
                    text: item.productCategories[0] || '--',
                    ...(item.productCategories.length > 1 && {
                      tag: {
                        tagContent: `+${item.productCategories.length - 1}`,
                        tagTooltipContent: item.productCategories.slice(1).join(', '),
                        showTooltipEvent: 'hover' as const,
                      },
                    }),
                  },
                ]
              : []),
            {
              type: 'TEXT_CELL',
              text: item.emailId || '--',
            },
            {
              type: 'TEXT_CELL',
              text: item.contactNumber || '--',
            },
            ...(showArchiveAction
              ? [
                  {
                    type: 'ACTION_CELL' as const,
                    actionType: 'ARCHIVE_USER' as const,
                    actionId: 'ARCHIVE_USER',
                    actionName: 'Archive employee',
                    asIcon: true,
                    showLargeIcon: true,
                  },
                ]
              : [
                  {
                    type: 'EMPTY_CELL' as const,
                  },
                ]),
          ],
        };
      },
    );
  },
};
